import { Card } from '@iwoca/orion';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './Documents.module.css';

export const DocumentsLoader = () => {
  return (
    <section className={styles.mainContent} data-testid="documents-loader">
      <div className={styles.documentsContainer}>
        <div className={styles.titleContainer}>
          <SkeletonTheme baseColor="#BAD1DE" height={24}>
            <Skeleton className={styles.titleLoading} width="30%" />
            <Skeleton className={styles.titleLoading} />
          </SkeletonTheme>
        </div>
        <Card className={styles.requirementLoading}>
          <SkeletonTheme height={28}>
            <Skeleton
              className={styles.requirementHeadingLoading}
              width={210}
            />
            <div className={styles.rightSection}>
              <Skeleton className={styles.pillLoading} width={90} />
              <Skeleton className={styles.pillLoading} width={18} height={18} />
            </div>
          </SkeletonTheme>
        </Card>
        <Card className={styles.requirementLoading}>
          <SkeletonTheme height={28}>
            <Skeleton
              className={styles.requirementHeadingLoading}
              width={160}
            />
            <div className={styles.rightSection}>
              <Skeleton className={styles.pillLoading} width={90} />
              <Skeleton className={styles.pillLoading} width={18} height={18} />
            </div>
          </SkeletonTheme>
        </Card>
        <Card className={styles.requirementLoading}>
          <SkeletonTheme height={28}>
            <Skeleton
              className={styles.requirementHeadingLoading}
              width={240}
            />
            <div className={styles.rightSection}>
              <Skeleton className={styles.pillLoading} width={90} />
              <Skeleton className={styles.pillLoading} width={18} height={18} />
            </div>
          </SkeletonTheme>
        </Card>
        <div className={styles.buttonContainer}>
          <Skeleton className={styles.buttonLoading} width={198} height={36} />
        </div>
      </div>
    </section>
  );
};
